export default __webpack_public_path__ + "static/media/LogoWhite.809dec29.svg";